<template>
  <div v-title data-title="助力成功" class="regthirddissuccess">
    <section class="sm-bg">
      <div class="act-user">
        <img :src="wechatheadimg" class="avatar" />
        <p>您已成功为{{parentwechatname}}助力</p>
      </div>
      <div class="sm-img">
        <img src="../../assets/img/liucheng.png" />
      </div>
    </section>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import guidethepublic from "../../assets/img/guidethepublic.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "fissionactivitysuccess",
  data: function() {
    return {
      LoginType: -1,
      formset: [],
      TotalCount: 0,
      disid: "",
      showguidethepublic: false,
      guidethepublic: guidethepublic,
      isSubscribe: "",
      wechatheadimg: "",
      parentwechatname: ""
    };
  },
  computed: {},
  created: function() {
    this.wechatheadimg = this.$route.query.wechatheadimg;
    this.parentwechatname = this.$route.query.parentwechatname;
    this.InitProduct();
  },
  mounted: function() {
    if (this.isSubscribe == 0) {
      this.showguidethepublic = true;
    }
  },
  methods: {
    InitProduct: function(type) {
      var data = {
        ProductName: "",
        IsOrderByPriceAsc: null,
        ProductTypes: [],
        ScenicareaId: null,
        HoltelId: null,
        PageSize: 4,
        PageNum: 1,
        LoginType: -1
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/tbproduct/productpager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginType = rep.Data.LoginType;
            this.formset = rep.Data.List;
            this.disid = rep.Data.DisGuid;
            var i = 0;
            for (; i < this.formset.length; i++) {
              if (this.formset[i].ProductName.length > 20) {
                this.formset[i].ProductName =
                  this.formset[i].ProductName.substring(0, 20) + "...";
              }
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    toHome() {
      this.$router.push("/app/home");
    },
    //产品详情
    ProductDetail: function(orderGuid) {
      if (this.LoginType == 4) {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid,
            disid: this.disid
          }
        });
      } else {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid
          }
        });
      }
    }
  }
};
</script>




<style>
.combo-price {
  color: red;
  font-size: 1.17rem;
}
.combo-qi {
  font-size: 0.75rem;
  color: #999;
}
.wv-button {
  float: right;
  margin-right: 5%;
}
.weui-form-preview__hd {
  line-height: 1.5em;
}

.weui-media-box__date {
  float: right;
}

.weui-form-preview__btns {
  width: 100%;
  text-align: right;
  padding-right: 20px;
  padding-bottom: 5px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: #3cc51f;
  display: block;
  flex: 1;
  position: relative;
}

.weui-media-box__content {
  text-align: right;
  float: right;
  width: 100%;
  font-size: 14px;
}

.fontsf {
  font-size: 14px;
  color: #000;
}

.fontsn {
  font-size: 14px;
}

.weui-form-preview__border {
  height: 10px;
  background-color: #efeff4;
}

.weui-search-bar {
  z-index: 9999;
}

.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 2em;
  padding-top: 70px;
  font-size: 1.5rem;
}

.search_left {
  width: 50%;
  text-align: center;
  float: left;
  background-color: #fff;
}

.weui-cells {
  margin-top: 0px;
}
.weui-zdycolors {
  color: #999;
}
.weui-spaces {
  height: 10px;
  background-color: #efeff4;
}
.needtomargin-top-wx {
  padding-top: 40px;
}
.needtomargin-top-common {
  padding-top: 90px;
}
.regthirddissuccess .wv-popup[data-v-f3183a8e] {
  background-color: initial !important;
}
</style>




// WEBPACK FOOTER //
// src/components/fissionactivity/fissionactivitysuccess.vue